// Icons
import CheckedIcon from '@shared/icons/CheckedIcon';
import StackIcon from '@shared/icons/StackIcon';
import ExchangeIcon from '@shared/icons/ExchangeIcon';
import PauseIcon from '@shared/icons/PauseIcon';
import CalendarStartIcon from '@shared/icons/CalendarStartIcon';
import UserPlusIcon from '@shared/icons/UserPlusIcon';
import UserMinusIcon from '@shared/icons/UserMinusIcon';
import EventNoteIcon from '@shared/icons/EventNoteIcon';
import DocumentIcon from '@shared/icons/DocumentIcon';
import { PlaneIcon } from '@shared/icons/PlaneIcon';
import { PauseCircleIcon } from '@shared/icons/PauseCircleIcon';
import { ExitIcon } from '@shared/icons/ExitIcon';
import { LoopIcon } from '@shared/icons/LoopIcon';
import { StopIcon } from '@shared/icons/StopIcon';
import ArchiveIcon from '@shared/icons/ArchiveIcon';
import UnarchiveIcon from '@shared/icons/UnarchiveIcon';
import ChangeRoleIcon from '@shared/icons/ChangeRoleIcon';
import SwapIcon from '@shared/icons/SwapIcon';
import FeedbackIcon from '@shared/icons/FeedbackIcon';
import RoomBookingIcon from '@shared/icons/RoomBookingIcon';
import TimeOffIcon from '@shared/icons/TimeOffIcon';
import MaintenanceIcon from '@shared/icons/MaintenanceIcon';
import RegistrationIcon from '@shared/icons/RegistrationIcon';

// Types
import { Project, ActivityType, ProjectMemberAdditionalRole, ProjectStatus } from '@shared/types';
import { EmployeeProjectAction, PROJECT_DATE_STATUS } from '@/types/project';
import { EmployeeTrainingStatus } from './employee';
import SuccessIcon from '@shared/icons/SuccessIcon';
export const ROLE_BADGE_COLOR_DEFAULT = '#8FBC8F';
export const PROJECT_INFO_DEFAULT = {
  NAME: '-',
  DESCRIPTION: '-',
  STATUS: ProjectStatus.WAITING_FOR_KICK_OFF
};
export const PROJECT_STATUS = {
  DEFAULT: 'waiting for kick-off',
  ACTIVE: 'active',
  COMPLETE: 'complete',
  PENDING: 'pending',
  REOPEN: 're-open',
  PAUSED: 'paused'
};
export const PROJECT_STATUS_VARIANTS = {
  [ProjectStatus.WAITING_FOR_KICK_OFF]: 'waiting',
  [ProjectStatus.ACTIVE]: 'active',
  [ProjectStatus.COMPLETED]: 'complete',
  [ProjectStatus.RESUMED]: 'reopen',
  [ProjectStatus.PAUSED]: 'pending'
} as const;
export const ACTION_HANDLER_STATUS = {
  COMPLETE: 'complete',
  INPROGRESS: 'inProgress',
  EXECUTING: 'executing'
};
export const TIMELINE_EVENT_ICON_MAP = {
  [ActivityType.PROJECT_COMPLETE]: {
    Icon: CheckedIcon,
    color: 'bg-grass'
  },
  [ActivityType.PROJECT_GO_LIVE]: {
    Icon: StackIcon,
    color: 'bg-tangerine'
  },
  [ActivityType.PROJECT_RESUME]: {
    Icon: ExchangeIcon,
    color: 'bg-ocean'
  },
  [ActivityType.PROJECT_PAUSE]: {
    Icon: PauseIcon,
    color: 'bg-crimson'
  },
  [ActivityType.PROJECT_RELEASE]: {
    Icon: CalendarStartIcon,
    color: 'bg-chartreuse'
  },
  [ActivityType.PROJECT_MEMBER_JOIN]: {
    Icon: UserPlusIcon,
    color: 'bg-midnight'
  },
  [ActivityType.PROJECT_MEMBER_LEAVE]: {
    Icon: UserMinusIcon,
    color: 'bg-amethyst'
  },
  [ActivityType.PROJECT_MEMBER_REMOVE]: {
    Icon: UserMinusIcon,
    color: 'bg-amethyst'
  },
  [ActivityType.PROJECT_MEMBER_ROLE_CHANGE]: {
    Icon: ChangeRoleIcon,
    color: 'bg-amethyst'
  },
  [ActivityType.PROJECT_KICK_OFF]: {
    Icon: EventNoteIcon,
    color: 'bg-grass'
  },
  [ActivityType.PROJECT_CREATE]: {
    Icon: DocumentIcon,
    color: 'bg-tangerine'
  },
  [ActivityType.PROJECT_MEMBER_RESUME]: {
    Icon: UserPlusIcon,
    color: 'bg-midnight'
  },
  [ActivityType.PROJECT_ARCHIVE]: {
    Icon: ArchiveIcon,
    color: 'bg-steel'
  },
  [ActivityType.PROJECT_UNARCHIVE]: {
    Icon: UnarchiveIcon,
    color: 'bg-cornflower'
  },
  [ActivityType.PROJECT_SCHEDULE_ACTIVITY]: {
    Icon: CalendarStartIcon,
    color: 'bg-chartreuse'
  },
  // Employee Activities
  [ActivityType.TRAINING_CREATE]: {
    Icon: DocumentIcon,
    color: 'bg-tangerine'
  },
  [ActivityType.TRAINING_START]: {
    Icon: DocumentIcon,
    color: 'bg-tangerine'
  },
  [ActivityType.TRAINING_COMPLETE]: {
    Icon: CheckedIcon,
    color: 'bg-grass'
  },
  [ActivityType.TRAINING_PAUSE]: {
    Icon: PauseIcon,
    color: 'bg-steel'
  },
  [ActivityType.TRAINING_RESUME]: {
    Icon: ExchangeIcon,
    color: 'bg-chartreuse'
  },
  [ActivityType.TRAINING_ARCHIVE]: {
    Icon: ArchiveIcon,
    color: 'bg-steel'
  },
  [ActivityType.TRAINING_UNARCHIVE]: {
    Icon: UnarchiveIcon,
    color: 'bg-chartreuse'
  },
  [ActivityType.TRAINING_FEEDBACK_RECEIVED]: {
    Icon: FeedbackIcon,
    color: 'bg-cornflower'
  },
  [ActivityType.TICKET_REALLOCATION]: {
    Icon: SwapIcon,
    color: 'bg-crimson'
  },
  [ActivityType.TICKET_ROOM_BOOKING]: {
    Icon: RoomBookingIcon,
    color: 'bg-tangerine'
  },
  [ActivityType.TICKET_TIME_OFF]: {
    Icon: TimeOffIcon,
    color: 'bg-ocean'
  },
  [ActivityType.TICKET_ON_BEHALF_TIME_OFF]: {
    Icon: TimeOffIcon,
    color: 'bg-ocean'
  },
  [ActivityType.TICKET_MAINTENANCE]: {
    Icon: MaintenanceIcon,
    color: 'bg-grass'
  },
  [ActivityType.TICKET_LUNCH_REGISTRATION]: {
    Icon: RegistrationIcon,
    color: 'bg-midnight'
  },
  [ActivityType.TICKET_ON_BEHALF_LUNCH_REGISTRATION]: {
    Icon: RegistrationIcon,
    color: 'bg-midnight'
  },
  // User relationship activities
  [ActivityType.EMPLOYEE_ASSIGN_MENTOR]: {
    Icon: UserPlusIcon,
    color: 'bg-cornflower'
  },
  [ActivityType.EMPLOYEE_ASSIGN_MENTEE]: {
    Icon: UserPlusIcon,
    color: 'bg-cornflower'
  },
  [ActivityType.EMPLOYEE_UNASSIGN_MENTOR]: {
    Icon: UserMinusIcon,
    color: 'bg-steel'
  },
  [ActivityType.EMPLOYEE_UNASSIGN_MENTEE]: {
    Icon: UserMinusIcon,
    color: 'bg-steel'
  },
  [ActivityType.TRAINING_ASSIGN_SUPPORTER]: {
    Icon: UserPlusIcon,
    color: 'bg-chartreuse'
  },
  [ActivityType.TRAINING_ASSIGN_TRAINEE]: {
    Icon: UserPlusIcon,
    color: 'bg-chartreuse'
  }
};
export const ACTIVITY_EVENT_ICON_MAP = {
  PROJECT_COMPLETE: TIMELINE_EVENT_ICON_MAP[ActivityType.PROJECT_COMPLETE],
  PROJECT_GO_LIVE: TIMELINE_EVENT_ICON_MAP[ActivityType.PROJECT_GO_LIVE],
  PROJECT_RESUME: TIMELINE_EVENT_ICON_MAP[ActivityType.PROJECT_RESUME],
  PROJECT_PAUSE: TIMELINE_EVENT_ICON_MAP[ActivityType.PROJECT_PAUSE],
  PROJECT_RELEASE: TIMELINE_EVENT_ICON_MAP[ActivityType.PROJECT_RELEASE],
  PROJECT_MEMBER_JOIN: TIMELINE_EVENT_ICON_MAP[ActivityType.PROJECT_MEMBER_JOIN],
  PROJECT_MEMBER_LEAVE: TIMELINE_EVENT_ICON_MAP[ActivityType.PROJECT_MEMBER_LEAVE],
  PROJECT_MEMBER_REMOVE: TIMELINE_EVENT_ICON_MAP[ActivityType.PROJECT_MEMBER_REMOVE],
  PROJECT_MEMBER_ROLE_CHANGE: TIMELINE_EVENT_ICON_MAP[ActivityType.PROJECT_MEMBER_ROLE_CHANGE],
  PROJECT_KICK_OFF: TIMELINE_EVENT_ICON_MAP[ActivityType.PROJECT_KICK_OFF],
  PROJECT_CREATE: TIMELINE_EVENT_ICON_MAP[ActivityType.PROJECT_CREATE],
  PROJECT_MEMBER_RESUME: TIMELINE_EVENT_ICON_MAP[ActivityType.PROJECT_MEMBER_RESUME],
  PROJECT_ARCHIVE: TIMELINE_EVENT_ICON_MAP[ActivityType.PROJECT_ARCHIVE],
  PROJECT_UNARCHIVE: TIMELINE_EVENT_ICON_MAP[ActivityType.PROJECT_UNARCHIVE],
  PROJECT_SCHEDULE_ACTIVITY: TIMELINE_EVENT_ICON_MAP[ActivityType.PROJECT_SCHEDULE_ACTIVITY],
  // Employee Activities
  TRAINING_CREATE: TIMELINE_EVENT_ICON_MAP[ActivityType.TRAINING_CREATE],
  TRAINING_START: TIMELINE_EVENT_ICON_MAP[ActivityType.TRAINING_START],
  TRAINING_COMPLETE: TIMELINE_EVENT_ICON_MAP[ActivityType.TRAINING_COMPLETE],
  TRAINING_PAUSE: TIMELINE_EVENT_ICON_MAP[ActivityType.TRAINING_PAUSE],
  TRAINING_RESUME: TIMELINE_EVENT_ICON_MAP[ActivityType.TRAINING_RESUME],
  TRAINING_ARCHIVE: TIMELINE_EVENT_ICON_MAP[ActivityType.TRAINING_ARCHIVE],
  TRAINING_UNARCHIVE: TIMELINE_EVENT_ICON_MAP[ActivityType.TRAINING_UNARCHIVE],
  TRAINING_FEEDBACK_RECEIVED: TIMELINE_EVENT_ICON_MAP[ActivityType.TRAINING_FEEDBACK_RECEIVED],
  TICKET_REALLOCATION: TIMELINE_EVENT_ICON_MAP[ActivityType.TICKET_REALLOCATION],
  TICKET_ROOM_BOOKING: TIMELINE_EVENT_ICON_MAP[ActivityType.TICKET_ROOM_BOOKING],
  TICKET_TIME_OFF: TIMELINE_EVENT_ICON_MAP[ActivityType.TICKET_TIME_OFF],
  TICKET_ON_BEHALF_TIME_OFF: TIMELINE_EVENT_ICON_MAP[ActivityType.TICKET_ON_BEHALF_TIME_OFF],
  TICKET_MAINTENANCE: TIMELINE_EVENT_ICON_MAP[ActivityType.TICKET_MAINTENANCE],
  TICKET_LUNCH_REGISTRATION: TIMELINE_EVENT_ICON_MAP[ActivityType.TICKET_LUNCH_REGISTRATION],
  TICKET_ON_BEHALF_LUNCH_REGISTRATION: TIMELINE_EVENT_ICON_MAP[ActivityType.TICKET_ON_BEHALF_LUNCH_REGISTRATION],
  // User relationship activities
  EMPLOYEE_ASSIGN_MENTOR: TIMELINE_EVENT_ICON_MAP[ActivityType.EMPLOYEE_ASSIGN_MENTOR],
  EMPLOYEE_ASSIGN_MENTEE: TIMELINE_EVENT_ICON_MAP[ActivityType.EMPLOYEE_ASSIGN_MENTEE],
  EMPLOYEE_UNASSIGN_MENTOR: TIMELINE_EVENT_ICON_MAP[ActivityType.EMPLOYEE_UNASSIGN_MENTOR],
  EMPLOYEE_UNASSIGN_MENTEE: TIMELINE_EVENT_ICON_MAP[ActivityType.EMPLOYEE_UNASSIGN_MENTEE],
  TRAINING_ASSIGN_SUPPORTER: TIMELINE_EVENT_ICON_MAP[ActivityType.TRAINING_ASSIGN_SUPPORTER]
} as const;
export const PROJECT_DATE_STATUS_LABEL = {
  [PROJECT_DATE_STATUS.JOINED]: 'Start Date',
  [PROJECT_DATE_STATUS.LEFT]: 'Left Date',
  [PROJECT_DATE_STATUS.RESUMED]: 'Resume Date',
  [PROJECT_DATE_STATUS.COMPLETED]: 'End Date',
  [PROJECT_DATE_STATUS.PAUSED]: 'Paused Date',
  [PROJECT_DATE_STATUS.ARCHIVED]: 'Archived Date',
  [PROJECT_DATE_STATUS.UNARCHIVED]: 'Unarchived Date'
};

// This label is used for employee project list in the Employee Insight page
export const EMPLOYEE_PROJECT_DATE_STATUS_LABEL = {
  [PROJECT_DATE_STATUS.JOINED]: 'Invited on',
  [PROJECT_DATE_STATUS.RESUMED]: 'Resumed on'
};
export const ADDITIONAL_ROLE_LABEL = {
  [ProjectMemberAdditionalRole.HOT_TRAINING]: 'Hot Training',
  [ProjectMemberAdditionalRole.SHADOW]: 'Shadow',
  [ProjectMemberAdditionalRole.SUPPORTER]: 'Supporter'
};
export const ICON_MAP_TO_DATE_STATUS = [{
  type: PROJECT_DATE_STATUS.JOINED,
  icon: PlaneIcon,
  color: '#404653'
}, {
  type: PROJECT_DATE_STATUS.LEFT,
  icon: ExitIcon,
  color: '#E4317A'
}, {
  type: PROJECT_DATE_STATUS.RESUMED,
  icon: LoopIcon,
  color: '#00548F'
}, {
  type: PROJECT_DATE_STATUS.COMPLETED,
  icon: StopIcon,
  color: '#009966'
}, {
  type: PROJECT_DATE_STATUS.PAUSED,
  icon: PauseCircleIcon,
  color: '#DC8925'
}, {
  type: PROJECT_DATE_STATUS.ARCHIVED,
  icon: ArchiveIcon,
  color: '#838AAA'
}, {
  type: PROJECT_DATE_STATUS.UNARCHIVED,
  icon: UnarchiveIcon,
  color: '#6B7CE5'
},
// Employee Training Status
{
  type: EmployeeTrainingStatus.IDLE,
  icon: PlaneIcon,
  color: '#404653'
}, {
  type: EmployeeTrainingStatus.IN_PROGRESS,
  icon: PlaneIcon,
  color: '#404653'
}, {
  type: EmployeeTrainingStatus.PAUSED,
  icon: PauseCircleIcon,
  color: '#DC8925'
}, {
  type: EmployeeTrainingStatus.RESUMED,
  icon: PlaneIcon,
  color: '#404653'
}, {
  type: EmployeeTrainingStatus.COMPLETED,
  icon: SuccessIcon,
  color: '#009966'
}] as const;
export const PROJECT_STATUS_LABEL = {
  [ProjectStatus.WAITING_FOR_KICK_OFF]: 'waiting for kick-off',
  [ProjectStatus.ACTIVE]: 'active',
  [ProjectStatus.COMPLETED]: 'completed',
  [ProjectStatus.RESUMED]: 'resumed',
  [ProjectStatus.PAUSED]: 'paused'
};
export const PROJECT_ACTIVITY_TYPE_VARIANTS = {
  [ActivityType.PROJECT_COMPLETE]: 'complete',
  [ActivityType.PROJECT_GO_LIVE]: 'active',
  [ActivityType.PROJECT_RESUME]: 'reopen',
  [ActivityType.PROJECT_PAUSE]: 'pending',
  [ActivityType.PROJECT_RELEASE]: 'active',
  [ActivityType.PROJECT_KICK_OFF]: 'active',
  [ActivityType.PROJECT_CREATE]: 'pending',
  [ActivityType.PROJECT_ARCHIVE]: 'archive'
} as const;
export const PROJECT_ACTIVITY_TYPE_LABEL = {
  [ActivityType.PROJECT_COMPLETE]: 'completed',
  [ActivityType.PROJECT_GO_LIVE]: 'active',
  [ActivityType.PROJECT_RESUME]: 'resumed',
  [ActivityType.PROJECT_PAUSE]: 'paused',
  [ActivityType.PROJECT_RELEASE]: 'active',
  [ActivityType.PROJECT_KICK_OFF]: 'active',
  [ActivityType.PROJECT_CREATE]: 'waiting for kick-off',
  [ActivityType.PROJECT_ARCHIVE]: 'archived'
};
export const CHATBOT_PROJECT_ACTIONS_ERRORS = {
  // COMPLETED PROJECT
  CANNOT_SAVE_COMPLETED_PROJECT: `The project is already finalized, inactive or pending. Please resume it prior to making any changes.`,
  CANNOT_RESUME_UNPAUSED_PROJECT: `This project is currently active and cannot be resumed unless it is paused or completed.`,
  CANNOT_RELEASE_INACTIVE_PROJECT: `The project is currently inactive and cannot be resumed, paused, or released until it has been started.`,
  MEMBERS_ARGS_MISSING: `Missing member's username to take action. Please try again.`,
  USER_ROLE_CANNOT_TAKE_ADMIN_ACTION: (project: string, action: string) => `You lack the necessary permissions. Only users with Admin role can execute ${action} on ${project}.`,
  CURRENT_ACTION_CANNOT_TAKE_ON_CURRENT_STATUS: (status: string, action: string) => `This project is currently in the ${status} state, so the ${action} operation cannot be performed. Please try again with a valid action.`,
  SAVE_PROJECT_UPDATED_EVENT_INVALID: (event: string, dateTime: string) => `Failed to update project event ${event} ${dateTime} due to invalid event. Please try again.`,
  HAPPENED_OFFICIAL_EVENT: (event: string, dateTime: string) => `This activity ${event} ${dateTime} has been already happened, so you cannot update it. Please try again.`,
  LACK_OF_DESC: `Please provide notes or description to update this event.`,
  // FRIENDLY OK MESSAGE
  UNFRIENDLY_RESPONSE: `OK.`,
  FRIENDLY_RESPONSE: `Got it! Let me know if you need anything else.`,
  // CANCEL MESSAGE
  CANCEL_ACTION: `The message was canceled mid-process and wasn’t handled successfully.`,
  INVALID_MEMBERS: `These members no longer exist or have left/completed the project. Please try again.`,
  // NAME
  SAVE_PROJECT_NAME_FAIL: 'Failed to save project name. Please try again.',
  SAVE_PROJECT_NAME_MISSING: 'Missing or invalid name. Please make sure to include the project name.',
  SAVE_PROJECT_NAME_SUCCESS: '✅ Project name saved successfully!',
  // DESCRIPTION
  SAVE_PROJECT_DESC_SUCCESS: '✅ Project description saved successfully!',
  SAVE_PROJECT_DESC_FAIL: 'Failed to save project description. Please try again.',
  SAVE_PROJECT_DESC_MISSING: 'Missing or invalid description. Please make sure to include the project description.',
  // TECHNICAL STACK
  SAVE_PROJECT_TECHNICAL_STACKS_SUCCESS: '✅ Project technical stacks saved successfully!',
  SAVE_PROJECT_TECHNICAL_STACKS_INVALID: 'The input is lack of intent add or remove, category or tech stack items. Please try again.',
  SAVE_PROJECT_TECHNICAL_STACKS_INVALID_CATEGORY: 'The input is lack of valid category. Please try again.',
  SAVE_PROJECT_TECHNICAL_STACKS_DUPLICATE: 'The input contains duplicate tech stack items. Please try again.',
  SAVE_PROJECT_TECHNICAL_STACKS_FAIL: 'Failed to save project technical stacks. Please try again.',
  // LOGO
  SAVE_PROJECT_LOGO_SUCCESS: '✅ Project logo saved successfully!',
  SAVE_PROJECT_LOGO_FAIL: 'Failed to save project logo. Please try again.',
  SAVE_PROJECT_LOGO_MISSING: 'Please include the logo you want to use when asking to update the logo.',
  SAVE_PROJECT_MEMBERS_SUCCESS: `✅ Project members saved successfully!`,
  SAVE_PROJECT_MEMBERS_FAIL: `Failed to save project members. Please try again.`,
  SAVE_PROJECT_MEMBERS_INVALID: `These members no longer exist or have left/completed the project. Please try again.`,
  SAVE_PROJECT_MEMBERS_LEAVE_SUCCESS: `✅ Project left members saved successfully!`,
  SAVE_PROJECT_MEMBERS_LEAVE_FAIL: `Failed to save left project members. Please try again.`,
  SAVE_PROJECT_MEMBERS_LEAVE_INVALID: `These members no longer exist or have left/completed the project. Please try again.`,
  SAVE_PROJECT_MEMBERS_REMOVE_SUCCESS: `✅ Project wrong invited members removed successfully!`,
  SAVE_PROJECT_MEMBERS_REMOVE_FAIL: `Failed to remove wrong invited members. Please try again.`,
  SAVE_PROJECT_MEMBERS_REMOVE_INVALID: `These members no longer exist or have left/completed the project. Please try again.`,
  SAVE_PROJECT_MEMBER_ROLE_SUCCESS: `✅ Project members's role saved successfully!`,
  SAVE_PROJECT_MEMBER_ROLE_FAIL: `Failed to save project members's role. Please try again.`,
  SAVE_PROJECT_MEMBERS_ROLE_INVALID: `These members no longer exist or have left/completed the project. Please try again.`,
  SAVE_PROJECT_MEMBERS_RESUME_SUCCESS: `✅ Project members's resumed successfully!`,
  SAVE_PROJECT_MEMBERS_RESUME_FAIL: `Failed to resume project members's. Please try again.`,
  SAVE_PROJECT_MEMBERS_RESUME_INVALID: `These members no longer exist or already joined project. Please try again.`,
  SAVE_PROJECT_MEMBERS_RESUME_MISSING: `Missing member's username to resume. Please try again.`,
  SAVE_PROJECT_EVENTS_SUCCESS: `✅ Project events was saved successfully!`,
  SAVE_PROJECT_EVENTS_FAIL: `Failed to save project events. Please try again.`,
  SAVE_PROJECT_EVENTS_INVALID: `Failed to save project events due to invalid action. Please try again.`,
  SAVE_PROJECT_UPDATED_EVENT_SUCCESS: `✅ Project events was updated successfully!`,
  SAVE_PROJECT_UPDATED_EVENT_FAIL: `Failed to update project events. Please try again.`,
  SAVE_PROJECT_UPDATED_EVENT_MISSING: `Missing arguments for project event or notes. Please try again.`
};
export const ADDITIONAL_ROLE_COLOR_MAP = {
  [ProjectMemberAdditionalRole.HOT_TRAINING]: '#6B6705',
  [ProjectMemberAdditionalRole.SHADOW]: '#091855',
  [ProjectMemberAdditionalRole.SUPPORTER]: '#E4317A'
};
export const PROJECT_MEMBER_ADDITIONAL_ROLE_LABEL = {
  [ProjectMemberAdditionalRole.HOT_TRAINING]: 'Hot Training',
  [ProjectMemberAdditionalRole.SHADOW]: 'Shadow',
  [ProjectMemberAdditionalRole.SUPPORTER]: 'Supporter'
};

// Titles for employee project info card
export const EMPLOYEE_PROJECT_ACTION_TITLE_MAP = {
  [EmployeeProjectAction.INVITE_MEMBER]: 'Invited',
  [EmployeeProjectAction.REMOVE_MEMBER]: 'Removed',
  [EmployeeProjectAction.LEAVE_MEMBER]: 'Left',
  [EmployeeProjectAction.RESUME_MEMBER]: 'Rejoined',
  [EmployeeProjectAction.CHANGE_ROLE_MEMBER]: 'Role changed'
} as const;
export const PROJECT_DEFAULT_VALUE = {
  project: {
    projectInfo: {
      name: '',
      desc: '',
      code: '',
      members: [],
      id: '',
      status: null,
      logo: '',
      start: '',
      end: '',
      updatedAt: '',
      stacks: []
    }
  } as unknown as Project
};
export const PROJECT_EVENTS = {
  CREATED: 'Event created',
  UPDATED: 'Event updated'
};
export const PROJECT_INFO = {
  DESC_SAVED: 'Description saved',
  NAME_SAVED: 'Name saved',
  TECH_STACK_SAVED: 'Technical stack saved',
  LOGO_SAVED: 'Logo saved'
};